// Appel HTTP vers GET /api/dashboard/summary — un seul endpoint, une seule
// requête au chargement du tableau de bord.

import { api } from "./client";
import type { DashboardSummary } from "./types";

export const dashboardApi = {
  summary: (currency?: string) =>
    api.get<DashboardSummary>(`/api/dashboard/summary${currency ? `?currency=${currency}` : ""}`),
};
